import React from 'react'

const Loader = () => {
  return (
  <div class="india-wins-loader">
    <span>I</span>
    <span>N</span>
    <span>D</span>
    <span>I</span>
    <span>A</span>
    <span className='p-2'></span>
    <span>W</span>
    <span>I</span>
    <span>N</span>
    <span>S</span>
  </div>
  )
}

export default Loader